/**
* Estructure the money with currency value
* @param {string} str string with the price type number.
* @return money number with europe money code ej. input 3.45 return €3,45
*/
export function concatRegexp(initial, exp) {
  const formating = Number(exp)
    .toLocaleString('de-DE', { style: "currency", currency: "EUR" })
    .replace(' €', '');

  return initial.replace(/\d+[.\d+.\d,]+\d{2}/g, formating)

}

/**
* Destructure the expression with the europe money code.
* @param {string} str string with the price.
* @return money number ej. input €3,45 return 3.45
*/
export function formatPrice(str) {
  return parseFloat(
    str
      .match(/\d+/g)
      .join(''),
  ) / 100;
}

/**
 * converts the price string, with commas, to a floating number
 */
export const convertStringToFloat = (number) => Number(number.replace(".", "").replace(",", "."))
